<!-- Component for select tag       -->
<script>
// import eventbus from '@src/state/EventBus'

export default {
  components: {},
  // Disable automatic attribute inheritance, so that $attrs are
  // passed to the <input>, even if it's not the root element.
  // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance

  // Change the v-model event name to `update` to avoid changing
  // the behavior of the native `input` event.
  // https://vuejs.org/v2/guide/components-custom-events.html#Customizing-Component-v-model
  model: {
    event: 'input',
  },
  props: {
    value: {
      type: Array,
      default() {
        return []
      },
    },
    label: {
      type: String,
      default() {
        return ''
      },
    },
    validation: {
      type: Object,
      default() {
        return {}
      },
    },
    valid: {
      type: Boolean,
      default() {
        return false
      },
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    name: {
      type: String,
      default() {
        return ''
      },
    },
    // eslint-disable-next-line vue/require-default-prop

    form: {
      type: String,
      default() {
        return ''
      },
    },
  },
  data() {
    return {
      selected: [],
      option: [],
      update: false,
    }
  },

  computed: {
    availableOptions() {
      return this.option.filter((opt) => this.selected.indexOf(opt) === -1)
    },
  },

  watch: {
    value(newVal, oldVal) {
      //   console.log(this.value)
      if (newVal !== oldVal) {
        this.update = false
        if (this.value === null) this.selected = []
        else this.selected = this.value
      }
    },
    selected(newVal, oldVal) {
      if (newVal !== oldVal && this.update) {
        if (this.selected.length === 0) this.$emit('update', null)
        else this.$emit('update', this.selected)
      }
    },
  },
  created() {
    this.option = this.options.options
  },
  beforeDestroy() {
    var doc = this.$refs.multiselect
    if (doc !== undefined) doc.innerHTML = ''
  },
  mounted() {
    if (this.value === null) {
      this.update = false
      this.selected = []
    } else {
      this.update = false
      this.selected = this.value
    }
    //   console.log(this.selected)
  },

  methods: {
    sendData(event) {
      // eventbus.$emit('testEvent', 'test')

      //    eventbus.$emit('testEvent', 'validate_all')
      //  console.log(this.selected)
      //  console.log(event)
      this.update = true
      /*  this.$refs[this.name].reset()
      this.$emit('update', event.target.value)
      //this.selected = event.target.value
    //  this.callDependency(event.target.value, true) */
    },
  },
}
// v-validate.disable="'required'"
</script>
<template>
  <div ref="multiselect">
    <div :class="$style.formGroup" class="formGroup mt20 mt10-sm">
      <div class="formFieldWrap">
        <label :for="name" :class="$style.fieldTitle" class="w100 FL">{{
          label
        }}</label>
        <div class="form-field w100 FL">
          <b-form-group>
            <!-- prop `add-on-change` is needed to enable adding tags vie the `change` event -->
            <b-form-tags
              v-model="selected"
              size="lg"
              add-on-change
              no-outer-focus
              class="mb-2"
            >
              <template
                v-slot="{
                  tags,
                  inputAttrs,
                  inputHandlers,
                  disabled,
                  removeTag,
                }"
              >
                <ul
                  v-if="tags.length > 0"
                  class="list-inline d-inline-block mb-2"
                >
                  <li v-for="tag in tags" :key="tag" class="list-inline-item">
                    <b-form-tag
                      :title="tag"
                      :disabled="disabled"
                      variant="primary"
                      @remove="removeTag(tag)"
                      >{{ tag }}</b-form-tag
                    >
                  </li>
                </ul>
                <b-form-select
                  :id="name"
                  v-bind="inputAttrs"
                  :disabled="disabled || availableOptions.length === 0"
                  :options="availableOptions"
                  v-on="inputHandlers"
                  @change="sendData"
                >
                  <template v-slot:first>
                    <!-- This is required to prevent bugs with Safari -->
                    <option disabled value="">-Select-</option>
                  </template>
                </b-form-select>
              </template>
            </b-form-tags>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.formGroup {
  max-width: 500px;
}
</style>
